// components/CompanyForm.js
import React, { useState, useEffect } from 'react';
import { Building2, Settings } from 'lucide-react';
import { getDefaultCompany, updateCompany } from '../data/companies';

const CompanyForm = ({ companyInfo, setCompanyInfo }) => {
  const [isEditable, setIsEditable] = useState(false);
  
  // 컴포넌트 마운트 시 기본 업체 정보 불러오기
  useEffect(() => {
    if (!companyInfo.name) {
      setCompanyInfo(getDefaultCompany());
    }
  }, []);
  
  // 업체 정보 저장
  const handleSaveCompanyInfo = () => {
    updateCompany(companyInfo);
    setIsEditable(false);
    alert('업체 정보가 저장되었습니다.');
  };

  return (
    <div className=" md:mb-4 lg:mb-10">
      <div className="flex items-center justify-between mb-3">
        <h3 className="ttext-sm font-medium flex items-center">

          업체 정보
        </h3>
        {isEditable ? (
          <div className="flex gap-2">
            <button
              onClick={handleSaveCompanyInfo}
              className="bg-blue-500 text-white px-3 py-1 rounded-md text-sm hover:bg-blue-600 transition-colors"
            >
              저장
            </button>
            <button
              onClick={() => setIsEditable(false)}
              className="bg-gray-500 text-white px-3 py-1 rounded-md text-sm hover:bg-gray-600 transition-colors"
            >
              취소
            </button>
          </div>
        ) : (
          <button
            onClick={() => setIsEditable(true)}
            className="bg-gray-100 hover:bg-gray-200 border border-gray-300 px-3 py-1 rounded-md text-sm flex items-center gap-1 transition-colors"
          >
            <Settings className="w-3 h-3" />
            정보 수정
          </button>
        )}
      </div>
      <div className="space-y-3">
        <input
          type="text"
          placeholder="업체명"
          value={companyInfo.name}
          onChange={(e) => setCompanyInfo({...companyInfo, name: e.target.value})}
          disabled={!isEditable}
          className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${!isEditable ? 'bg-gray-50 text-gray-500' : ''}`}
        />
        <input
          type="text"
          placeholder="주소"
          value={companyInfo.address}
          onChange={(e) => setCompanyInfo({...companyInfo, address: e.target.value})}
          disabled={!isEditable}
          className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${!isEditable ? 'bg-gray-50 text-gray-500' : ''}`}
        />
        <div className="grid grid-cols-2 gap-3">
          <input
            type="text"
            placeholder="전화번호"
            value={companyInfo.phone}
            onChange={(e) => setCompanyInfo({...companyInfo, phone: e.target.value})}
            disabled={!isEditable}
            className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${!isEditable ? 'bg-gray-50 text-gray-500' : ''}`}
          />
          <input
            type="text"
            placeholder="사업자번호"
            value={companyInfo.businessNumber}
            onChange={(e) => setCompanyInfo({...companyInfo, businessNumber: e.target.value})}
            disabled={!isEditable}
            className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${!isEditable ? 'bg-gray-50 text-gray-500' : ''}`}
          />
        </div>
        <input
          type="email"
          placeholder="이메일"
          value={companyInfo.email}
          onChange={(e) => setCompanyInfo({...companyInfo, email: e.target.value})}
          disabled={!isEditable}
          className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${!isEditable ? 'bg-gray-50 text-gray-500' : ''}`}
        />
      </div>
    </div>
  );
};

export default CompanyForm;